"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosNoteClassificationReferenceSchema = void 0;
exports.normalizeFragranceName = normalizeFragranceName;
const zod_1 = require("zod");
const id_schema_1 = require("../../common/id.schema");
const fragrance_schema_1 = require("./fragrance.schema");
/**
 * Module 29 — Oil Blending (Phase 2)
 *
 * NoteClassificationReference — seed lookup table used by the auto-classifier
 * (`lib/classifier.ts`).
 *
 * Table layout (infrastructure/dynamodb-agenticpos):
 *   PK = tenantId           (or `_global` for the shared seed; current seeder
 *                            writes one copy per tenant for write-isolation)
 *   SK = name_normalized    (lowercased, punctuation/whitespace stripped)
 *
 * The classifier always queries the caller's tenantId first. Tenants may add
 * custom rows on top of the seeded set.
 */
exports.APosNoteClassificationReferenceSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    name_normalized: zod_1.z
        .string()
        .min(1)
        .max(120)
        .describe('lowercased, trimmed, punctuation/spaces stripped'),
    // Original human-readable name (kept for display in admin tools).
    display_name: zod_1.z.string().min(1).max(160).optional(),
    note_classification: fragrance_schema_1.APosFragranceNoteClassificationSchema,
    scent_family: fragrance_schema_1.APosFragranceScentFamilySchema,
    source: zod_1.z.enum(['seed', 'manual']).default('seed'),
    // Optional notes — supplier source, IFRA reference, etc.
    notes: zod_1.z.string().max(1000).optional(),
    createdAt: zod_1.z.number().describe('Unix ms'),
    updatedAt: zod_1.z.number().describe('Unix ms'),
});
/** Normalize a fragrance name to the SK shape: lowercase, strip non-alphanumerics. */
function normalizeFragranceName(name) {
    return name.toLowerCase().replace(/[^a-z0-9]+/g, '');
}
//# sourceMappingURL=note-classification-reference.schema.js.map